module.exports = __webpack_public_path__ + "img/triangle.be5030ca.webp";